import axios from 'axios';
export default (payload) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}prescription-discounts`, payload)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
